import { ModelInstance, BaseModel, ToFrontHook, ToBackHook } from './util';
import { File } from './file';

@ModelInstance({
  mappingFields: {
    id: 'id',
    title: 'title',
    picture: 'picture',
    link: 'link',
    sort: 'sort',
  },
  relation: {
    picture: File
  }
})
export class LeaguePartner extends BaseModel {
  id: number;
  title: string;
  picture: File;
  link: string;
  sort: number;

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}
